import { jsx as t } from "react/jsx-runtime";
import "react";
import p from "@mui/material/Box";
import { b as a } from "./shadows-DovTEXlb.js";
import "@mui/material";
const f = ({ shadowSize: o, children: m, ...r }) => /* @__PURE__ */ t(
  p,
  {
    boxShadow: a[o],
    ...r,
    children: m
  }
);
export {
  f as S
};
